<template>
  <div>
  	<Slide />
  	<Form />
  </div>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Form from '@/components/Form.vue'

export default {
  name: 'home',
  components: {
    Slide,
    Form
  }
}
</script>
